import { isRecord } from "./http";
import { zonedParts } from "./slots";

export interface LunacalConfig {
  base: string;
  user: string;
  event: string;
  duration: string;
}

function trimBase(base: string): string {
  return base.endsWith("/") ? base.slice(0, -1) : base;
}

export function upstreamUrl(cfg: LunacalConfig, fromIso: string, toIso: string): string {
  const input = {
    json: {
      isTeamEvent: false,
      usernameList: [cfg.user],
      eventTypeSlug: cfg.event,
      startTime: fromIso,
      endTime: toIso,
      timeZone: "UTC",
      duration: cfg.duration,
      rescheduleUid: null,
      orgSlug: null,
    },
    meta: {
      values: {
        rescheduleUid: ["undefined"],
        orgSlug: ["undefined"],
      },
    },
  };
  return `${trimBase(cfg.base)}/api/trpc/public/slots.getSchedule?input=${encodeURIComponent(JSON.stringify(input))}`;
}

export function parseSlotsStrict(payload: unknown): number[] | null {
  if (!isRecord(payload)) return null;
  const result = payload.result;
  if (!isRecord(result)) return null;
  const data = result.data;
  if (!isRecord(data)) return null;
  const json = data.json;
  if (!isRecord(json)) return null;
  const slots = json.slots;
  if (!isRecord(slots)) return null;
  const mins: number[] = [];
  const seen = new Set<number>();
  for (const arr of Object.values(slots)) {
    if (!Array.isArray(arr)) continue;
    for (const item of arr) {
      if (!isRecord(item) || typeof item.time !== "string") continue;
      const ms = Date.parse(item.time);
      if (!Number.isFinite(ms)) continue;
      const epoch = Math.floor(ms / 60_000);
      if (!seen.has(epoch)) {
        seen.add(epoch);
        mins.push(epoch);
      }
    }
  }
  mins.sort((a, b) => a - b);
  return mins;
}

export function bookingBaseUrl(cfg: LunacalConfig): string {
  const base = trimBase(cfg.base);
  if (!base.toLowerCase().startsWith("https://")) return "";
  return `${base}/${cfg.user}/${cfg.event}`;
}

export function bookingUrl(cfg: LunacalConfig, epochMin: number, tz: string): string {
  const base = trimBase(cfg.base);
  if (!base.toLowerCase().startsWith("https://")) {
    return `${base}/${cfg.user}`;
  }
  const parts = zonedParts(epochMin, tz);
  const date = parts.date;
  const month = date.slice(0, 7);
  const slot = new Date(epochMin * 60_000).toISOString();
  const u = new URL(`${base}/${cfg.user}/${cfg.event}`);
  u.searchParams.set("date", date);
  u.searchParams.set("month", month);
  u.searchParams.set("slots", slot);
  return u.toString();
}

export function freeCells(
  slotEpochMins: number[],
  cellStarts: number[],
  cellMin: number,
  slotLenMin: number,
): number[] {
  if (slotLenMin <= 0 || cellMin <= 0) return [];
  const open = new Set(slotEpochMins);
  const out: number[] = [];
  for (const start of cellStarts) {
    let covered = true;
    for (let t = start; t < start + cellMin; t += slotLenMin) {
      if (!open.has(t)) {
        covered = false;
        break;
      }
    }
    if (covered) out.push(start);
  }
  return out;
}
